import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  useLocation,
  Outlet,
} from "react-router-dom";
import "./App.css";
import { AbsoluteUpload } from "./components";
import { useAuth } from "./store/useAuth";
import { useEffect, useLayoutEffect } from "react";
import axios from "axios";
import LoginScreen from "./pages/Auth/LoginScreen";
// import HomeScreen from "./pages/Home/HomeScreen";
import ArticlesScreen from "./pages/Articles/ArticlesScreen";
import CommunityScreen from "./pages/Community/CommunityScreen";
import DropLocationsScreen from "./pages/DropLocations/DropLocationsScreen";
import DropsScreen from "./pages/Drops/DropsScreen";
import MarketPricingScreen from "./pages/MarketPricing/MarketPricingScreen";
import UsersScreen from "./pages/Users/UsersScreen";
import EditUserScreen from "./pages/Users/EditUserScreen";
import PendingDeletionsScreen from "./pages/Users/PendingDeletionsScreen";
import AddMarketPricing from "./pages/MarketPricing/AddMarketPricing";
import AddUserScreen from "./pages/Users/AddUserScreen";
import AddCommunityScreen from "./pages/Community/AddCommunityScreen";
import AddDropLocationScreen from "./pages/DropLocations/AddDropLocationScreen";
import AddArticleScreen from "./pages/Articles/AddArticleScreen";
import DropDetailsScreen from "./pages/Drops/DropDetailsScreen";
import LocalProvider from "./layouts/LocalProvider";
import EditArticleScreen from "./pages/Articles/EditArticleScreen";
import ArticlesCategoriesScreen from "./pages/Articles/ArticlesCategoriesScreen";
import AddArticleCategoryScreen from "./pages/Articles/AddArticleCategoryScreen";
import EditArticleCategoryScreen from "./pages/Articles/EditArticleCategoryScreen";
import EditDropLocationScreen from "./pages/DropLocations/EditDropLocationScreen";
import BadgesScreen from "./pages/Badges/BadgesScreen";
import AddBadgeScreen from "./pages/Badges/AddBadgeScreen";
import EditBadgeScreen from "./pages/Badges/EditBadgeScreen";
import EditCommunityScreen from "./pages/Community/EditCommunityScreen";
import EditMarketPricing from "./pages/MarketPricing/EditMarketPricing";
import PrivacyPolicyScreen from "./pages/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditionsScreen from "./pages/TermsAndConditions/TermsAndConditions";
import AddDropScreen from "./pages/Drops/AddDropScreen";
import LeadingSources from "./pages/LeadingSource/LeadingSources";
import AddLeadingSourceScreen from "./pages/LeadingSource/AddLeadingSourceScreen";
import EditLeadingSourceScreen from "./pages/LeadingSource/EditLeadingSourceScreen";
import ProfileScreen from "./pages/Profile/ProfileScreen";
import TomraDropsScreen from "./pages/TomraDrops/TomraDropsScreen";
import TomraDropDetailsScreen from "./pages/TomraDrops/TomraDropDetailsScreen";
import StatiegeldProductsScreen from "./pages/StatiegeldProducts/StatiegeldProductsScreen";
import AddStatiegeldProduct from "./pages/StatiegeldProducts/AddStatiegeldProduct";
import EditStatiegeldProductScreen from "./pages/StatiegeldProducts/EditStatiegeldProductScreen";
import StatiegeldStatsScreen from "./pages/StatiegeldStats/StatiegeldStatsScreen";
import ProductUsersListScreen from "./pages/StatiegeldStats/ProductUsersList/ProductUsersListScreen";
import UserProfileBadgesScreen from "./pages/UserProfileBadges/UserProfileBadgesScreen";
import AddUserProfileBadgeScreen from "./pages/UserProfileBadges/AddUserProfileBadgeScreen";
import EditUserProfileBadgeScreen from "./pages/UserProfileBadges/EditUserProfileBadgeScreen";
import AppInfoScreen from "./pages/AppInfo/RecyclingInfoScreen";
import HowItWorksPage from "./pages/HowItWorks/HowItWorksPage";
import AddAppInfoScreen from "./pages/AppInfo/AddAppInfoScreen";
import EditAppInfoScreen from "./pages/AppInfo/EditAppInfoScreen";
import AddNotificationScreen from "./pages/Notifications/AddNotificationScreen";
import NotificationsScreen from "./pages/Notifications/NotificationsScreen";
import TomraMachinesScreen from "./pages/TomraMachines/TomraMachinesScreen";
import AddTomraMachineScreen from "./pages/TomraMachines/AddTomraMachineScreen";
import EditTomraMachineScreen from "./pages/TomraMachines/EditTomraMachineScreen";
import DonationsScreen from "./pages/Donations/DonationsScreen";
import DropsStatsScreen from "./pages/Drops/DropsStatsScreen";
import QualityInputScreen from "./pages/QualityInput/QualityInputScreen";
import AddQualityInputScreen from "./pages/QualityInput/AddQualityInputScreen";
import EditQualityInputScreen from "./pages/QualityInput/EditQualityInputScreen";
import DataCarriersScreen from "./pages/DataCarrier/DataCarriersScreen";
import PlasticsScreen from "./pages/QualityInput/PlasticsScreen";
import ParcelScreen from "./pages/Parcels/ParcelScreen";
import AddParcelScreen from "./pages/Parcels/AddParcelScreen";
import EditParcelScreen from "./pages/Parcels/EditParcelScreen";
import ParcelStatsNewScreen from "./pages/Parcels/ParcelStatsNewScreen";
import OnboardingScreen from "./pages/Onboardings/OnboardingScreen";
import AddOnboardingScreen from "./pages/Onboardings/AddOnboardingScreen";
import EditOnboardingScreen from "./pages/Onboardings/EditOnboardingScreen";
import BeevisionMachinesScreen from "./pages/BeeVisionMachines/BeevisionMachinesScreen";
import AddBeevisionMachineScreen from "./pages/BeeVisionMachines/AddBeevisionMachineScreen";
import EditBeevisionMachineScreen from "./pages/BeeVisionMachines/EditBeevisionMachineScreen";
import BeevisionAuditLogsPage from "./pages/BeevisionAuditLogs";
import BeevisionDropsScreen from "./pages/BeevisionDrops/BeevisionDropsScreen";
import BeevisionDropDetailsScreen from "./pages/BeevisionDrops/BeevisionDropDetailsScreen";
import DropbotLoadingAdScreen from "./pages/Dropbot/DropbotLoadingAdScreen";
import CourierParcelScreen from "./pages/Parcels/CourierParcelScreen";
import ParcelHandoffsScreen from "./pages/ParcelHandoffs/ParcelHandoffsScreen";
import PartnersScreen from "./pages/Partners/PartnersScreen";
import CarrierPartnersScreen from "./pages/Partners/CarrierPartnersScreen";
import AddPartnerScreen from "./pages/Partners/AddPartnerScreen";
import EditPartnerScreen from "./pages/Partners/EditPartnerScreen";
import VoucherDetailsScreen from "./pages/Partners/VoucherDetailsScreen";
import PendingVoucherCodesScreen from "./pages/Partners/PendingVoucherCodesScreen";
import PartnerChallengesScreen from "./pages/Partners/Challenges/PartnerChallengesScreen";
import ChallengeVouchersScreen from "./pages/Partners/Challenges/ChallengeVouchersScreen";
import AddPartnerChallengeScreen from "./pages/Partners/Challenges/AddPartnerChallengeScreen";
import EditPartnerChallengeScreen from "./pages/Partners/Challenges/EditPartnerChallengeScreen";
import LotteryScreen from "./pages/Lottery/LotteryScreen";
import AddLotteryScreen from "./pages/Lottery/AddLotteryScreen";
import EditLotteryScreen from "./pages/Lottery/EditLotteryScreen";
import CopyLotteryScreen from "./pages/Lottery/CopyLotteryScreen";
import LotteryVouchersScreen from "./pages/Lottery/LotteryVouchersScreen";
import LotteryNotificationsScreen from "./pages/Lottery/LotteryNotificationsScreen";
import ConversionScreen from "./pages/PlasticDashboard/ConversionScreen";
import PlasticVolumesScreen from "./pages/PlasticDashboard/PlasticVolumesScreen";
import VolumesScreen from "./pages/Volumes/VolumesScreen";
// import SummaryScreen from "./pages/Home/SummaryScreen";
import NewUserStatsScreen from "./pages/Users/NewUserStatsScreen";
import ConversionStatsNewScreen from "./pages/Users/ConversionStatsNewScreen";
import MaterialFeedbackScreen from "./pages/Users/MaterialFeedbackScreen";
import { useSummaryStats } from "./store/useSummaryStats";
import WithdrawsScreen from "./pages/Withdraws/WithdrawsScreen";
import TransactionLogsScreen from "./pages/TransactionLogs/TransactionLogsScreen";
import MergeAccountsScreen from "./pages/MergeAccounts/MergeAccountsScreen";
import AccountReviewScreen from "./pages/AccountReview/AccountReviewScreen";
import WebhookSimulatorScreen from "./pages/Simulator/WebhookSimulatorScreen";
import NewStatiegeldStatsScreen from "./pages/StatiegeldStats/NewStatiegeldStatsScreen";
import SummaryDashboardScreen from "./pages/Home/SummaryDashboardScreen";
import Graveyard from "./pages/Graveyard/Graveyard";
import BenchmarkingGraphs from "./pages/DropLocations/BenchmarkingGraphs";
import CommunityDetail from "./pages/Community/CommunityDetail";
import RevenuesScreen from "./pages/Revenues/Revenues";
import UsersScreenReporting from "./pages/Users/UsersScreenReporting";
import PaymentsScreen from "./pages/Payments/PaymentsScreen";
import ParcelReportScreen from "./pages/ParcelReport/ParcelReportScreen";
import SummaryScreen from "./pages/Summary/SummaryScreen";
import StoreOpsScreen from "./pages/StoreOps/StoreOpsScreen";
// import EditMarketPricing from "./pages/MarketPricing/EditMarketPricing";
import MobileAnalyticsScreen from "./pages/Analytics/MobileAnalyticsScreen";
import KpiScreen from "./pages/Graveyard/KpiScreen";

function RootLayout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location.pathname]);

  return (
    <LocalProvider>
      <>
        <Outlet />
        <AbsoluteUpload />
      </>
    </LocalProvider>
  );
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RootLayout />}>
      <Route path="/" element={<SummaryScreen />} />
      {/* <Route path="/" element={<SummaryScreenV2 />} /> */}
      {/* <Route path="/impact-metrics" element={<ImpactMetricsScreen />} /> */}
      <Route path="/summary-dashboard" element={<SummaryDashboardScreen />} />
      <Route path="/volumes" element={<VolumesScreen />} />
      <Route path="/revenues" element={<RevenuesScreen />} />
      <Route path="/store-ops" element={<StoreOpsScreen />} />
      <Route path="/parcel-report" element={<ParcelReportScreen />} />
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/profile" element={<ProfileScreen />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyScreen />} />
      <Route
        path="/terms-and-conditions"
        element={<TermsAndConditionsScreen />}
      />
      {/* Articles */}
      <Route path="/articles" element={<ArticlesScreen />} />
      <Route path="/add-article" element={<AddArticleScreen />} />
      <Route path="/edit-article/:id" element={<EditArticleScreen />} />
      <Route
        path="/article-categories"
        element={<ArticlesCategoriesScreen />}
      />
      <Route
        path="/add-article-category"
        element={<AddArticleCategoryScreen />}
      />
      <Route
        path="/edit-article-category/:id"
        element={<EditArticleCategoryScreen />}
      />
      {/* Communities */}
      <Route path="/community" element={<CommunityScreen />} />
      <Route path="/community-detail/:id" element={<CommunityDetail />} />
      <Route path="/add-community" element={<AddCommunityScreen />} />
      <Route path="/edit-community/:id" element={<EditCommunityScreen />} />
      {/* Drop Locations */}
      <Route path="/drop-locations" element={<DropLocationsScreen />} />
      <Route path="/add-drop-locations" element={<AddDropLocationScreen />} />
      <Route
        path="/edit-drop-locations/:id"
        element={<EditDropLocationScreen />}
      />
      <Route path="/benchmarking-graphs" element={<BenchmarkingGraphs />} />
      {/* Drops */}
      {/* <Route path="/drops-data" element={<DropsDataScreen />} /> */}
      <Route path="/drops-data" element={<DropsScreen />} />
      <Route path="/drops-stats" element={<DropsStatsScreen />} />
      <Route path="/edit-drop/:id" element={<DropDetailsScreen />} />
      <Route path="/add-drop" element={<AddDropScreen />} />
      <Route path="/add-drop/:userId" element={<AddDropScreen />} />
      {/* Statiegeld Drops */}
      <Route path="/tomra-drops" element={<TomraDropsScreen />} />
      <Route path="/edit-tomra-drop/:id" element={<TomraDropDetailsScreen />} />
      {/* Statiegeld Stats */}
      <Route path="/statiegeld-stats" element={<StatiegeldStatsScreen />} />
      <Route
        path="/new-statiegeld-stats"
        element={<NewStatiegeldStatsScreen />}
      />
      <Route
        path="/statiegeld-product-users-list/:type/:id"
        element={<ProductUsersListScreen />}
      />
      {/* Statiegeld Products */}
      <Route
        path="/statiegeld-products"
        element={<StatiegeldProductsScreen />}
      />
      <Route
        path="/add-statiegeld-product"
        element={<AddStatiegeldProduct />}
      />
      <Route
        path="/edit-statiegeld-product/:id"
        element={<EditStatiegeldProductScreen />}
      />
      {/* Tomra Machines */}
      <Route path="/tomra-machines" element={<TomraMachinesScreen />} />
      <Route path="/add-tomra-machine" element={<AddTomraMachineScreen />} />
      <Route
        path="/edit-tomra-machine/:id"
        element={<EditTomraMachineScreen />}
      />
      {/* Strea economic */}
      <Route path="/market-pricing" element={<MarketPricingScreen />} />
      <Route
        path="/pending-deletions"
        element={<PendingDeletionsScreen />}
      />
      <Route path="/add-market-pricing" element={<AddMarketPricing />} />
      <Route path="/edit-market-pricing/:id" element={<EditMarketPricing />} />
      {/* Users */}
      <Route path="/new-user-stats" element={<NewUserStatsScreen />} />
      <Route
        path="/conversion-stats-new"
        element={<ConversionStatsNewScreen />}
      />
      <Route path="/material-feedback" element={<MaterialFeedbackScreen />} />
      <Route path="/users-v2" element={<UsersScreenReporting />} />
      <Route path="/payments" element={<PaymentsScreen />} />
      <Route path="/users" element={<UsersScreen />} />
      <Route path="/withdraws" element={<WithdrawsScreen />} />
      <Route path="/transaction-logs" element={<TransactionLogsScreen />} />
      <Route path="/merge-accounts" element={<MergeAccountsScreen />} />
      <Route path="/account-review" element={<AccountReviewScreen />} />
      <Route path="/simulator" element={<WebhookSimulatorScreen />} />
      <Route path="/mobile-analytics" element={<MobileAnalyticsScreen />} />
      <Route path="/edit-user/:id" element={<EditUserScreen />} />
      <Route path="/add-user" element={<AddUserScreen />} />
      {/* Badges */}
      <Route path="/badges" element={<BadgesScreen />} />
      <Route path="/add-badge" element={<AddBadgeScreen />} />
      <Route path="/edit-badge/:id" element={<EditBadgeScreen />} />
      {/* User Profile Badges */}
      <Route
        path="/user-profile-badges"
        element={<UserProfileBadgesScreen />}
      />
      <Route
        path="/add-user-profile-badge"
        element={<AddUserProfileBadgeScreen />}
      />
      <Route
        path="/edit-user-profile-badge/:id"
        element={<EditUserProfileBadgeScreen />}
      />
      {/* Leading Sources */}
      <Route path="/leading-sources" element={<LeadingSources />} />
      <Route path="/add-leading-source" element={<AddLeadingSourceScreen />} />
      <Route
        path="/edit-leading-source/:id"
        element={<EditLeadingSourceScreen />}
      />
      {/* Donations */}
      <Route path="/donations" element={<DonationsScreen />} />
      {/* AppInfos */}
      <Route path="/appinfo" element={<AppInfoScreen />} />
      {/* How it works sheet editor */}
      <Route path="/how-it-works" element={<HowItWorksPage />} />
      <Route path="/add-appinfo" element={<AddAppInfoScreen />} />
      <Route path="/edit-appinfo/:id" element={<EditAppInfoScreen />} />
      {/* Notifications */}
      <Route path="/notifications" element={<NotificationsScreen />} />
      <Route path="/add-notification" element={<AddNotificationScreen />} />
      {/* Quality Inputs */}
      <Route path="/quality-inputs" element={<QualityInputScreen />} />
      <Route path="/quality-inputs/plastics" element={<PlasticsScreen />} />
      <Route path="/add-quality-input" element={<AddQualityInputScreen />} />
      <Route
        path="/edit-quality-input/:id"
        element={<EditQualityInputScreen />}
      />
      {/* Data Carriers */}
      <Route path="/data-carriers" element={<DataCarriersScreen />} />
      {/* Parcel */}
      <Route path="/parcels" element={<ParcelScreen />} />
      <Route
        path="/view-courier-parcel/:courierId"
        element={<CourierParcelScreen />}
      />
      <Route path="/add-parcel" element={<AddParcelScreen />} />
      <Route path="/edit-parcel/:id" element={<EditParcelScreen />} />
      <Route path="/parcel-stats-new" element={<ParcelStatsNewScreen />} />
      <Route path="/parcel-handoffs" element={<ParcelHandoffsScreen />} />
      {/* Onboardings */}
      <Route path="/onboardings" element={<OnboardingScreen />} />
      <Route path="/add-onboarding" element={<AddOnboardingScreen />} />
      <Route path="/edit-onboarding/:id" element={<EditOnboardingScreen />} />
      {/* Beevision Drops */}
      <Route path="/beevision-drops" element={<BeevisionDropsScreen />} />
      <Route
        path="/edit-beevision-drop/:id"
        element={<BeevisionDropDetailsScreen />}
      />
      {/* Beevision Machines */}
      <Route path="/beevision-machines" element={<BeevisionMachinesScreen />} />
      <Route
        path="/add-beevision-machine"
        element={<AddBeevisionMachineScreen />}
      />
      <Route
        path="/edit-beevision-machine/:id"
        element={<EditBeevisionMachineScreen />}
      />
      {/* Beevision Audit Logs */}
      <Route
        path="/beevision-audit-logs/*"
        element={<BeevisionAuditLogsPage />}
      />
      {/* Dropbot Loading Ad */}
      <Route path="/dropbot-loading-ad" element={<DropbotLoadingAdScreen />} />
      {/* Partners */}
      <Route path="/partners" element={<PartnersScreen />} />
      <Route path="/carrier-partners" element={<CarrierPartnersScreen />} />
      <Route path="/add-partner" element={<AddPartnerScreen />} />
      <Route path="/edit-partner/:id" element={<EditPartnerScreen />} />
      <Route path="/voucher-details/:id" element={<VoucherDetailsScreen />} />
      <Route
        path="/pending-voucher-codes"
        element={<PendingVoucherCodesScreen />}
      />
      {/* Partner Challenges */}
      <Route path="/partner-challenges" element={<PartnerChallengesScreen />} />
      <Route
        path="/add-partner-challenge"
        element={<AddPartnerChallengeScreen />}
      />
      <Route
        path="/edit-partner-challenge/:id"
        element={<EditPartnerChallengeScreen />}
      />
      {/* Lottery */}
      <Route path="/lottery" element={<LotteryScreen />} />
      <Route path="/add-lottery" element={<AddLotteryScreen />} />
      <Route path="/edit-lottery/:id" element={<EditLotteryScreen />} />
      <Route path="/copy-lottery/:id" element={<CopyLotteryScreen />} />
      <Route path="/lottery-vouchers" element={<LotteryVouchersScreen />} />
      <Route
        path="/lottery-notifications"
        element={<LotteryNotificationsScreen />}
      />
      <Route path="/challenge-vouchers" element={<ChallengeVouchersScreen />} />

      {/* Plastic Dashboard */}
      <Route
        path="/plastic-dashboard/conversion"
        element={<ConversionScreen />}
      />
      <Route
        path="/plastic-dashboard/volumes"
        element={<PlasticVolumesScreen />}
      />

      {/* Graveyard */}
      <Route path="/graveyard" element={<Graveyard />} />
      <Route path="/kpi-screen" element={<KpiScreen />} />
    </Route>
  )
);

function App() {
  /** Hooks */
  const { accessToken, getUser } = useAuth();
  useSummaryStats();

  // Ensure axios auth header + user are loaded after refresh
  useEffect(() => {
    if (accessToken) {
      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
      getUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken]);
  useLayoutEffect(() => {
    if (process.env.REACT_APP_ENV === "staging") {
      document.title = "Staging - Droppie Dashboard";
    }
  }, []);
  return <RouterProvider router={router} />;
}

export default App;
